import { StyleSheet } from 'aphrodite/no-important';
import { colour } from '../style/base-theme';

export const styles = StyleSheet.create({
  panelWrapper: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    alignItems: 'flex-start'
  },
  panelTitle: {
    flex: 1,
    fontSize: 16,
    fontWeight: 600,
    color: colour.grey[200],
    marginBottom: 0
  },
  h4: {
    flex: 1,
    flexGrow: 1,
    color: colour.brand.orange,
    fontSize: 28,
    fontWeight: 600,
    margin: 0
  },
  p: {
    flex: 1,
    flexGrow: 2,
    color: colour.grey[400],
    fontSize: 14,
    margin: 0
  },
  highlight: {
    color: colour.grey[200],
    fontWeight: 600
  }
});
